import { gql } from 'apollo-boost';


export const fragments = {

    CATEGORIES: {
        QUERY_RETURN: `id name displayName subCategories{ id displayName }`
    },

    CATEGORY: {
        QUERY_RETURN:    `id name displayName description subCategories{ id displayName }`,
        MUTATION_RETURN: `id name displayName description`,
        EDIT_FIELDS:     `id name displayName description refIdCode`,
    },

    SUBCATEGORIES: {
        QUERY_RETURN: `id name displayName categoryId ordinal`
    },

    SUBCATEGORY: {
        QUERY_RETURN:    `id name displayName description categoryId ordinal`,
        MUTATION_RETURN: `id name displayName description categoryId ordinal`,
        EDIT_FIELDS:     `id name displayName description categoryId ordinal refIdCode`,
    },

    BUSINESS_FUNCTIONS: {
        QUERY_RETURN: `id name description refIdCode resourceCode colorValue iconName isArchived`,
    },

    BUSINESS_FUNCTION: {
        QUERY_RETURN:    `id name description refIdCode resourceCode colorValue iconName isArchived`,
        MUTATION_RETURN: `id name description refIdCode resourceCode colorValue iconName isArchived`,
        EDIT_FIELDS:     `id name description refIdCode resourceCode colorValue iconName isArchived`,
    },
};

export const queries = {

    GET_CATEGORIES: ( returnQueryString = fragments.CATEGORIES.QUERY_RETURN ) => gql`
        query GetCategories( $order: [CategorySortInput!], $where: CategoryFilterInput ){
            categories( order: $order, where: $where){
                ${ returnQueryString }
            }
        }`,

    GET_CATEGORY: ( returnQueryString = fragments.CATEGORY.QUERY_RETURN ) => gql`
        query GetCategories( $id: Uuid! ){
            category( id: $id ) {
                ${ returnQueryString }
            }
        }`,

    GET_ACTIVITTY_CATEGORIES: ( returnQueryString = fragments.CATEGORIES.QUERY_RETURN ) => gql`
        query GetActivityCategories( $input: ActivityCategoriesQueryInput!, $order: [CategorySortInput!] ){
            activityCategories( input: $input, order: $order ) {
                ${ returnQueryString }
            }
        }`,

    GET_SUBCATEGORIES: ( returnQueryString = fragments.SUBCATEGORIES.QUERY_RETURN ) => gql`
        query GetSubCategories( $order: [SubCategorySortInput!], $where: SubCategoryFilterInput ){
            subCategories( order: $order, where: $where){
                ${ returnQueryString }
            }
        }`,

    GET_SUBCATEGORY: ( returnQueryString = fragments.SUBCATEGORY.QUERY_RETURN ) => gql`
        query GetSubCategory( $id: Uuid! ){
            subCategories( where: { id: { eq: $id } } ) {
                ${ returnQueryString }
            }
        }`,

    GET_BUSINESS_FUNCTIONS: ( returnQueryString = fragments.BUSINESS_FUNCTIONS.QUERY_RETURN ) => {

        const query = `
            query GetBusinessFunctions( 
                $order: [BusinessFunctionSortInput!], 
                $where: BusinessFunctionFilterInput ){
                businessFunctions( order: $order, where: $where){
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

    GET_BUSINESS_FUNCTION: ( returnQueryString = fragments.BUSINESS_FUNCTION.QUERY_RETURN ) => {

        const query = `
            query GetBusinessFunction( $id: Uuid! ){
                businessFunctions( where: { id: { eq: $id } } ) {
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

};

export const mutations = {

    /* CATEGORIES */

    CREATE_CATEGORY: ( returnQueryString = fragments.CATEGORY.MUTATION_RETURN ) => gql`
        mutation CreateCategory( $input: CategoryCreateCommandInput! ){
            createCategory( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    UPDATE_CATEGORY: ( returnQueryString = fragments.CATEGORY.MUTATION_RETURN ) => gql`
        mutation UpdateCategory( $input: CategoryUpdateCommandInput! ){
            updateCategory( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    DELETE_CATEGORY: () => gql`
        mutation DeleteCategory( $input: CategoryDeleteCommandInput! ){
            deleteCategory( input: $input )
        }`,

    UPDATE_CATEGORY_ORDER: ( returnQueryString = fragments.CATEGORY.MUTATION_RETURN ) => gql`
        mutation UpdateCategoryOrder( $input: CategoryUpdateOrdinalsCommandInput! ){
            updateCategoryOrdinals( input: $input ){
                ${ returnQueryString }
            }
        }`,

    /* SUB CATEGORIES */

    CREATE_SUBCATEGORY: ( returnQueryString = fragments.SUBCATEGORY.MUTATION_RETURN ) => gql`
        mutation CreateSubCategory( $input: SubCategoryCreateCommandInput! ){
            createSubCategory( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    UPDATE_SUBCATEGORY: ( returnQueryString = fragments.SUBCATEGORY.MUTATION_RETURN ) => gql`
        mutation UpdateSubCategory( $input: SubCategoryUpdateCommandInput! ){
            updateSubCategory( input: $input ) {
                ${ returnQueryString }
            }
        }`,

    DELETE_SUBCATEGORY: () => gql`
        mutation DeleteSubCategory( $input: SubCategoryDeleteCommandInput! ){
            deleteSubCategory( input: $input )
        }`,

    UPDATE_SUBCATEGORY_ORDER: ( returnQueryString = fragments.SUBCATEGORY.MUTATION_RETURN ) => gql`
        mutation UpdateSubCategoryOrder( $input: SubCategoryUpdateOrdinalsCommandInput! ){
            updateSubCategoryOrdinals( input: $input ){
                ${ returnQueryString }
            }
        }`,

    /* BUSINESS FUNCTIONS */

    CREATE_BUSINESS_FUNCTION: ( returnQueryString = fragments.BUSINESS_FUNCTION.MUTATION_RETURN ) => {

        const query = `
            mutation CreateBusinessFunction( $input: BusinessFunctionCreateCommandInput! ){
                createBusinessFunction( input: $input ) {
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

    UPDATE_BUSINESS_FUNCTION: ( returnQueryString = fragments.BUSINESS_FUNCTION.MUTATION_RETURN ) => {

        const query = `
            mutation UpdateBusinessFunction( $input: BusinessFunctionUpdateCommandInput! ){
                updateBusinessFunction( input: $input ) {
                    ${ returnQueryString }
                }
            }`;

        return gql( query );
    },

    DELETE_BUSINESS_FUNCTION: () => {

        const query = `
            mutation DeleteBusinessFunction( $input: BusinessFunctionDeleteCommandInput! ){
                deleteBusinessFunction( input: $input )
            }`;

        return gql( query );
    },
};

export const functions = {};

export const CategoryQueries = {
    fragments,
    queries,
    mutations,
    functions,
};
